import { isMacOS as n } from "@scalar/helpers/general/is-mac-os";
import { HOTKEY_LABELS as e, MODIFIER_KEY_SYMBOLS_MACOS as i, MODIFIER_KEY_SYMBOLS as f } from "./constants.js";
function u(t) {
  return t === "default";
}
function m(t) {
  const o = u(t) ? "Meta" : t;
  return n() ? i[o] : f[o];
}
function c(t, o) {
  return [...o.map((r) => m(r)), t];
}
function s(t) {
  return t in e ? e[t] : t;
}
export {
  c as formatHotkeySymbols,
  s as getKeyLabel,
  m as getModifierKeySymbol,
  u as isDefault
};
